module.exports = __webpack_public_path__ + "static/media/jangl-logo@2x.ee5846e6.png";